export default {
  title: '生产批次',
  addBatch: '添加生产批次',
  batchInfo: '批次信息',
  batchInfoPlaceholder: '请输入批次ID、批次名称',
  productInfo: '产品信息',
  productInfoPlaceholder: '请输入产品名称',
  productNoLabel: '产品编号：',
  id: 'ID',
  batchName: '批次名称',
  createTime: '创建时间',
  batchNameLabel: '批次名称',
  batchNamePlaceholder: '请输入批次名称',
  batchNameRequired: '请输入批次名称',
  batchNameMax: '最多30个字符',
  relatedProduct: '关联产品',
  selectSku: '选择SKU',
  skuPlaceholder: 'SKU',
  productionDate: '生产日期',
  productionDatePlaceholder: '请选择生产日期',
  productionDateRequired: '请选择生产日期',
  shelfLife: '保质期',
  shelfLifeRequired: '请选择保质期类型',
  validityMode: '有效期模式',
  validityModeRequired: '请选择有效期模式',
  validityModePlaceholder: '请选择有效期模式',
  validityNum: '有效时间',
  validityNumRequired: '请输入有效时间',
  validDays: '按天数',
  validMonths: '按月份',
  validDate: '有效日期',
  validityYears: '按年份',
  validityLongTerm: '长期有效',
  validDaysPlaceholder: '请输入有效天数',
  validDaysRequired: '请输入有效天数',
  validMonthsPlaceholder: '请输入有效月数',
  validMonthsRequired: '请输入有效月数',
  validDatePlaceholder: '请选择有效日期',
  validDateRequired: '请选择有效日期',
  validityYearsPlaceholder: '请输入有效年数',
  relatedProductRequired: '请选择关联产品',
  remark: '备注',
  remarkPlaceholder: '请输入备注',
  factory: '生产工厂',
  inspectionReport: '检验报告',
  inspectionReportTip: '请上传检验报告图片',
  selectProductTitle: '选择产品',
  productName: '产品名称',
  productNamePlaceholder: '请输入产品名称',
  spec: '规格',
  category: '产品分类',
  retailPrice: '产品零售价',
  select: '选择',
};
